import React, { useState } from 'react';
import { Card } from '../../../../../components/Card/Card';
import { PermissionButton } from '../../../../../components/Button/PermissionButton';
import { Event, updateEventDetails } from '../../../../../model/event';
import { ModalController, ControlledModal } from '../../../../../components/Modal/ControlledModal';
import { handleError } from '../../../../../model/notification';
import { AsyncSearch } from '../../../../../components/Form/AsyncSearch/AsyncSearch';
import { t } from '../../../../../locales/translate';
import { Form, useChanges } from '../../../../../components/Form/Form';

interface Props {
  event: Event;
}

export function Owner({ event }: Props): JSX.Element {
  const [modal, setModal] = useState(false);

  return (
    <section>
      <Card
        title={t.model.event.owner}
        actions={
          <PermissionButton name="edit" model={event} permission="update_owner" onClick={() => setModal(true)} />
        }
      >
        {(event.owningCompany && event.owningCompany.name) ||
          t.errors.noItemsforThisCollection(t.model.event.owner, t.model.event._name)}
      </Card>
      <ControlledModal<{ owningCompanyId?: string }>
        open={modal}
        model={{
          owningCompanyId: (event.owningCompany && event.owningCompany.id) || '',
        }}
        onClose={() => setModal(false)}
        title={t.model.event.updateOwningCompany}
        size="small"
      >
        {(controller) => <OwnerForm controller={controller} eventId={event.id} />}
      </ControlledModal>
    </section>
  );
}

function OwnerForm({
  controller,
  eventId,
}: {
  controller: ModalController<{ owningCompanyId?: string }>;
  eventId: string;
}): JSX.Element {
  const [changes, , model, trackChanges] = useChanges<{
    owningCompanyId?: string;
  }>(controller.model);

  async function handleOnSubmit(): Promise<void> {
    try {
      await updateEventDetails({
        eventId,
        changes,
      });
      controller.close();
    } catch (error) {
      handleError(error);
    }
  }

  return (
    <Form model={model} onInput={trackChanges}>
      {(form) => {
        controller.configure({
          onSubmit: handleOnSubmit,
          canSubmit: form.valid,
        });
        return (
          <>
            <AsyncSearch name="owningCompanyId" label={t.model.company._plural} searchIn={['company']} required />
          </>
        );
      }}
    </Form>
  );
}
